export default function Paragraph ({
  data,
  className,
}: {
  data: string;
  className: string;
}) {
  return (
    <p className={className} dangerouslySetInnerHTML={{ __html: data }}></p>
  )
}
